import * as CartConstants from "../constants/cart.constant";
import { Loading } from "../utils/helpers/constants";
import { deleteItemHelper } from "../utils/helpers/dataHelper";

const initialState = {
  cart: {},
  cartItems: [],
  cartItem: {},
  cartLoading: "",
  addToCartLoading: "",
  deleteCartLoading: "",
  totalCartItems: 0,
  cartOutstandingAlumniFee: 0,
  noFeeCartLoading: "",
};

const cartReducer = (state = initialState, action) => {
  const currentCartList = [...state.cartItems];
  switch (action.type) {
    case CartConstants.ADD_TO_CART_REQUEST:
      return { ...state, addToCartLoading: Loading.FETCHING };

    case CartConstants.ADD_TO_CART_SUCCESS:
      return {
        ...state,
        addToCartLoading: Loading.SUCCESS,
      };

    case CartConstants.ADD_TO_CART_ERROR:
      return { ...state, addToCartLoading: Loading.ERROR };

    case CartConstants.FETCH_CART_REQUEST:
      return { ...state, cartLoading: Loading.FETCHING };

    case CartConstants.FETCH_CART_SUCCESS:
      return {
        ...state,
        cart: action.payload,
        cartOutstandingAlumniFee: action.payload.outstandingAlumniFee,
        cartItems: action.payload.cartItems,
        cartLoading: Loading.SUCCESS,
      };

    case CartConstants.FETCH_CART_ERROR:
      return { ...state, cartLoading: Loading.ERROR };

    case CartConstants.FETCH_CART_NO_FEE_REQUEST:
      return { ...state, noFeeCartLoading: true };

    case CartConstants.FETCH_CART_NO_FEE_SUCCESS:
      return {
        ...state,
        cart: action.payload,
        cartOutstandingAlumniFee: action.payload.outstandingAlumniFee,
        cartItems: action.payload.cartItems,
        noFeeCartLoading: false,
      };

    case CartConstants.FETCH_CART_NO_FEE_ERROR:
      return { ...state, noFeeCartLoading: false };

    case CartConstants.REMOVE_CART_ITEM_REQUEST:
      // return { ...state, deleteCartLoading: setLoading(state, action) };
      return {
        ...state,
        deleteCartLoading: Loading.FETCHING,
      };

    case CartConstants.REMOVE_CART_ITEM_SUCCESS:
      const newList = deleteItemHelper(
        currentCartList,
        action.payload.id,
        "id"
      );
      return {
        ...state,
        cartItems: newList,
        // deleteCartLoading: setLoading(state, action),
        deleteCartLoading: Loading.SUCCESS,
      };

    case CartConstants.REMOVE_CART_ITEM_ERROR:
      // return { ...state, deleteCartLoading: setLoading(state, action) };
      return {
        ...state,
        deleteCartLoading: Loading.ERROR,
      };

    case CartConstants.REMOVE_ALL_CART_ITEM_REQUEST:
      return { ...state, deleteCartLoading: Loading.FETCHING };

    case CartConstants.REMOVE_ALL_CART_ITEM_SUCCESS:
      return {
        ...state,
        deleteCartLoading: Loading.SUCCESS,
      };

    case CartConstants.REMOVE_ALL_CART_ITEM_ERROR:
      return { ...state, deleteCartLoading: Loading.ERROR };

    case CartConstants.FETCH_TOTAL_CART_ITEMS_REQUEST:
      return { ...state, cartLoading: Loading.FETCHING };

    case CartConstants.FETCH_TOTAL_CART_ITEMS_SUCCESS:
      return {
        ...state,
        totalCartItems: action.payload,
        cartLoading: Loading.SUCCESS,
      };

    case CartConstants.FETCH_TOTAL_CART_ITEMS_ERROR:
      return { ...state, cartLoading: Loading.ERROR };

    default:
      return state;
  }
};

export default cartReducer;
